// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getBallotStyleSlates, getBallotStyleSlatesCoverage, } from "@sequentech/ui-core";
import { sortCandidatesInBallotOrder, sortContestsInBallotOrder } from "./ContestOrder";
import { ESlateOfficesLayout, getSlateOffices } from "./SlateCoverage";
export { getSlateName } from "@sequentech/ui-core";
var resolveSlate = function (slate, contests) { return ({
    id: slate.id,
    name: slate.name,
    contests: contests.flatMap(function (contest) {
        var _a;
        var memberIds = (_a = slate.members[contest.id]) !== null && _a !== void 0 ? _a : [];
        var candidates = memberIds.flatMap(function (id) { var _a; return (_a = contest.candidates.find(function (candidate) { return candidate.id === id; })) !== null && _a !== void 0 ? _a : []; });
        return candidates.length > 0 ? [{ contest: contest, candidates: candidates }] : [];
    }),
}); };
var resolveCoveredSlate = function (slate, contests, coverage) { return ({
    id: slate.id,
    name: slate.name,
    contests: getSlateOffices(coverage, contests, ESlateOfficesLayout.STACKED),
    coverage: coverage,
    offices: getSlateOffices(coverage, contests, ESlateOfficesLayout.ALIGNED),
}); };
var candidatesInBallotOrder = function (slateContest) { return (__assign(__assign({}, slateContest), { candidates: sortCandidatesInBallotOrder(slateContest.contest, slateContest.candidates) })); };
var inBallotOrder = function (slate) {
    var _a;
    return (__assign(__assign({}, slate), { contests: slate.contests.map(candidatesInBallotOrder), offices: (_a = slate.offices) === null || _a === void 0 ? void 0 : _a.map(candidatesInBallotOrder) }));
};
/**
 * The slates of a ballot, with the contests and candidates in ballot order. With `coverage`,
 * only the slates it lists are kept, with the candidates it counts.
 */
export var resolveSlates = function (config, ballotContests, coverage) {
    var contests = sortContestsInBallotOrder(ballotContests);
    var resolved = coverage
        ? coverage.flatMap(function (slateCoverage) {
            var slate = config.slates.find(function (entry) { return entry.id === slateCoverage.slate_id; });
            return slate ? [resolveCoveredSlate(slate, contests, slateCoverage)] : [];
        })
        : config.slates
            .map(function (slate) { return resolveSlate(slate, contests); })
            .filter(function (slate) { return slate.contests.length > 0; });
    var slates = resolved.map(inBallotOrder);
    var covered = new Set(slates.flatMap(function (slate) { return slate.contests.map(function (_a) {
        var contest = _a.contest;
        return contest.id;
    }); }));
    return {
        mobileCandidateLists: config.mobile_candidate_lists,
        slates: slates,
        contests: contests.filter(function (contest) { return covered.has(contest.id); }),
    };
};
/**
 * The slates of a ballot, or null when its election has none. Throws the
 * problems of an invalid configuration, as `getBallotStyleSlates` does.
 */
export var resolveBallotStyleSlates = function (ballotEml) {
    var config = getBallotStyleSlates(ballotEml);
    return config
        ? resolveSlates(config, ballotEml.contests, getBallotStyleSlatesCoverage(ballotEml))
        : null;
};
var isSlateProblem = function (value) {
    return typeof value === "object" &&
        value !== null &&
        typeof value.message === "string";
};
/** Why a ballot's slate configuration is refused, or undefined when it is sound. */
export var getSlateConfigurationProblem = function (ballotEml) {
    try {
        getBallotStyleSlates(ballotEml);
        return undefined;
    }
    catch (error) {
        var first = (Array.isArray(error) ? error : [error])[0];
        return isSlateProblem(first) ? first.message : String(first);
    }
};
